// 校验中心
const validateWords = {
  account: {
    empty: '用户名不能为空',
    wrong: '用户名输入错误',
    used: '用户名已占用',
    bannedWord: '用户名不能含有特殊字符',
  },
  passportName_whds: {
    empty: '通行证账号不能为空',
    wrong: '通行证账号输入错误',
    used: '通行证账号已占用',
    bannedWord: '通行证账号不能含有特殊字符',
  },
  name: {
    empty: '姓名不能为空',
    length: '姓名长度应为2~10个字符',
  },
  loginAccount: {
    empty: '登录账号不能为空',
    wrong: '登录账号输入错误',
    used: '登录账号已占用',
    bannedWord: '登录账号不能含有特殊字符',
  },
  password_whds: {
    empty: '请输入密码',
    wrong: '密码输入不正确',
  },
  imgCode: {
    empty: '请输入验证码',
    wrong: '验证码不正确',
  },
  phone: {
    empty: '请填写手机号',
    wrong: '手机号格式不符',
  },
  smsCode: {
    empty: '请输入手机短信验证码',
    wrong: '手机短信验证码应该为6位数字',
  },
  email: {
    empty: '请输入邮箱',
    wrong: '邮箱格式不正确',
  },
  barName: {
    empty: '请输入网吧名称',
    wrong: '网吧名称应该为4-16个中英文或符号',
  },
  labelName: {
    empty: '请输入服务器标签名称',
    wrong: '服务器标签名称应该为1-16个中英文',
  },
  ruleName: {
    empty: '请输入内容',
    wrong: '长度为1-128个中英文',
  },
  groupName: {
    empty: '请输入内容',
    wrong: '长度为1-16个汉字',
  },
  ip: {
    empty: 'ip地址不能为空',
    wrong: 'ip地址输入错误',
  },
  port: {
    empty: '请输入端口',
    wrong: '端口输入错误',
  },
  proc: {
    empty: '请输入进程信息',
    wrong: '端口输入错误',
  },
  MD5: {
    wrong: '格式错误',
  },
  Hash: {
    wrong: '格式错误',
  },
  sign: {
    wrong: '格式错误',
  },
  Company: {
    wrong: '格式错误',
  },
};

class validateCenter {
  constructor() {}
  sendRes(bool, str) {
    // 返回信息
    return {
      res: bool,
      msg: str,
    };
  }
  checkEmpty(val) {
    // 校验空值
    if (val.toString().trim() == '') {
      return true;
    } else {
      return false;
    }
  }
  // 通行证校验
  passportNameWhds(val) {
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.passportName_whds.empty);
    }
    val = val.toString().trim();
    if (val.length >= 4 && val.length <= 16) {
      return this.sendRes(true);
    } else {
      return this.sendRes(false, validateWords.passportName_whds.wrong);
    }
  }
  name(val) {
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.name.empty);
    }
    if (val.trim().length > 10 && val.trim().length < 2) {
      return this.sendRes(false, validateWords.name.length);
    }
    return this.sendRes(true);
  }
  // 网吧名校验
  barName(val) {
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.barName.empty);
    }
    if (val.trim().length > 16 || val.trim().length < 4) {
      return this.sendRes(false, validateWords.barName.wrong);
    }
    return this.sendRes(true);
  }
  labelName(val) {
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.labelName.empty);
    }
    if (val.trim().length > 16 || val.trim().length < 1) {
      return this.sendRes(false, validateWords.labelName.wrong);
    }
    return this.sendRes(true);
  }
  ruleName(val) {
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.ruleName.empty);
    }
    if (val.trim().length > 128 || val.trim().length < 1) {
      return this.sendRes(false, validateWords.ruleName.wrong);
    }
    return this.sendRes(true);
  }
  groupName(val) {
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.groupName.empty);
    }
    if (val.trim().length > 16 || val.trim().length < 1) {
      return this.sendRes(false, validateWords.groupName.wrong);
    }
    return this.sendRes(true);
  }
  loginAccount(val) {
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.loginAccount.empty);
    }
    val = val.toString().trim();
    if (val.length >= 6 && val.length <= 16) {
      return this.sendRes(true);
    } else {
      return this.sendRes(false, validateWords.loginAccount.wrong);
    }
  }
  passwordWhds(val) {
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.password_whds.empty);
    }
    val = val.toString().trim();
    if (val.length >= 6 && val.length <= 16) {
      return this.sendRes(true);
    } else {
      return this.sendRes(false, validateWords.password_whds.wrong);
    }
  }
  phoneNum(val) {
    // 手机号校验
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.phone.empty);
    }
    if (/^1\d{10}$/.test(val.trim())) {
      return this.sendRes(true);
    } else {
      return this.sendRes(false, validateWords.phone.wrong);
    }
  }
  email(val) {
    // 邮箱校验
    let reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.email.empty);
    }
    if (!reg.test(val.trim())) {
      return this.sendRes(false, validateWords.email.wrong);
    } else {
      return this.sendRes(true);
    }
  }
  smsCode(val) {
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.smsCode.empty);
    }
    if (/\d{6}/.test(val.trim())) {
      return this.sendRes(true);
    } else {
      return this.sendRes(false, validateWords.smsCode.wrong);
    }
  }
  imgCode(val) {
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.imgCode.empty);
    }
    if (val.trim().length != 4) {
      return this.sendRes(false, validateWords.imgCode.wrong);
    } else {
      return this.sendRes(true);
    }
  }
  ip(val) {
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.ip.empty);
    } else {
      return this.sendRes(true);
    }
    // if (/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(val.trim())) {
    //     return this.sendRes(false, validateWords.ip.wrong);
    // }
  }
  port(val) {
    val += '';
    if (this.checkEmpty(val)) {
      return this.sendRes(false, validateWords.port.empty);
    }
    if (val.trim() < 0 || val.trim() > 65535) {
      return this.sendRes(false, validateWords.port.wrong);
    } else {
      return this.sendRes(true);
    }
  }
  MD5(val) {
    let msg = '';
    // let reg = /^[\da-zA-Z]{32}$/i
    let reg = /[^\w\/]/gi;
    if (reg.test(val) || val.length != 32) {
      msg = '格式错误';
    }
    return msg;
  }
  Hash(val) {
    let msg = '';
    let reg = /[^\w\/]/gi;
    if (reg.test(val) || val.length != 8) {
      msg = '格式错误';
    }
    return msg;
  }
  Sign(val) {
    let msg = '';
    let reg = /[^\w\/]/gi;
    if (reg.test(val)) {
      msg = '格式错误';
    } else {
      if (val.length == 32 || val.length == 20 || val.length == 38) {
        msg = '';
      } else {
        msg = '格式错误';
      }
    }
    return msg;
  }
  SignName(val) {
    let msg = '';
    let reg = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\.\,]/g;
    if (val.indexOf('?') != -1 || val.indexOf('*') != -1 || val.length > 64) {
      msg = '格式错误';
    }
    return msg;
  }
  cmdlineCheck(val) {
    let msg = '';
    if (val == '') {
      msg = '格式错误';
    }
    return msg;
  }
  company(val) {
    let msg = '';
    let reg = /[^\w\/]{1,255}$/gi;
    if (reg.test(val)) {
      msg = '格式错误';
    }
    return msg;
  }
  Path(val) {
    let msg = '';
    let reg = /[^\w\/]{1,255}$/gi;
    if (reg.test(val)) {
      msg = '格式错误';
    }
    return msg;
  }
  proName(val) {
    let msg = '';
    if (val.length > 0 && val.length <= 255) {
      if (val.indexOf('\\') != -1) {
        msg = '不可包含“\\”，可输入：名称、*、null';
      }
    } else {
      msg = '请输入0~255之间名称信息';
    }
    return msg;
  }
  proPath(val) {
    let msg = '';
    if (val.length > 0 && val.length <= 255) {
      console.log(222);
    } else {
      msg = '请输入进程信息';
    }
    return msg;
  }
  checkPro(type, val) {
    if (type == 'Name') {
      return this.proName(val);
    } else if (type == 'Path') {
      return this.proPath(val);
    } else if (type == 'MD5') {
      return this.MD5(val);
    } else if (type == 'Hash') {
      return this.Hash(val);
    } else if (type == 'Sign') {
      return this.Sign(val);
    } else if (type == 'SignName') {
      return this.SignName(val);
    } else if (type == 'cmdline') {
      return this.cmdlineCheck(val);
    }
  }
  isHashLine(val) {
    let msg = 0;
    let reg = /\*\\/g;
    if (reg.test(val)) {
      msg = 1;
    }
    return msg;
  }
  isRouteHas(val) {
    let msg = 0;
    if (val.indexOf('*') == 0 || val == 'null') {
      msg = 1;
    }
    return msg;
  }
  fileCheck(val) {
    let msg = 0;
    if (val.indexOf('\\') == 0) {
      msg = 1;
    }
    return msg;
  }
  reginCheck(val) {
    let msg = '';
    if (
      val.indexOf('\\') == 0 ||
      val.indexOf('HKEY_CLASSES_ROOT') == 0 ||
      val.indexOf('HKEY_CURRENT_USER') == 0 ||
      val.indexOf('HKEY_LOCAL_MACHINE') == 0 ||
      val.indexOf('HKEY_USERS') == 0 ||
      val.indexOf('HKEY_CURRENT_CONFIG') == 0
    ) {
      msg = '*' + val;
    } else if (val.indexOf('*\\') == 0 || val.indexOf('*') == 0) {
      msg = val;
    } else {
      msg = '"*\\' + val + '\\*"';
    }

    return msg;
  }
  lastIndexOf(str, c) {
    let x = str.indexOf(c);
    if (x == -1) {
      return x;
    }
    for (var i = 0; i < str.length - x; i++) {
      let index = str.indexOf(c, x + 1);
      if (index == -1) {
        break;
      }
      x = index;
    }
    return x;
  }
  replacepos(text, start, stop, replacetext) {
    let mystr = text.substring(0, start) + replacetext + text.substring(stop);
    return mystr;
  }
}
export default new validateCenter();
